import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QuoteContext } from '../assets/context/QuoteContext';
import { useAuth } from '../assets/context/AuthContext';
import DraftAuthModal from './DraftAuthModal';

function DraftSaveControl({ currentStep, overrides = {} }) {
    const navigate = useNavigate();
    const { draftId, saveDraft } = useContext(QuoteContext);
    const { isLoggedIn } = useAuth();
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [feedback, setFeedback] = useState('');

    const persistDraft = async () => {
        setIsSaving(true);
        setFeedback('');
        try {
            await saveDraft(currentStep, overrides);
            setIsAuthModalOpen(false);
            navigate('/Bookings', { state: { draftSaved: true } });
        } catch (error) {
            setFeedback(error.message || 'Unable to save this draft.');
            throw error;
        } finally {
            setIsSaving(false);
        }
    };

    const handleSave = () => {
        if (!isLoggedIn) {
            setIsAuthModalOpen(true);
            return;
        }
        persistDraft().catch(() => {});
    };

    return (
        <>
            <div className="draft-save-row">
                <p>Need more time? Save your progress and come back whenever you’re ready.</p>
                <button type="button" className="draft-save-btn" onClick={handleSave} disabled={isSaving}>
                    {isSaving ? 'Saving draft…' : `${draftId ? 'Update' : 'Save'} draft & exit ↗`}
                </button>
            </div>
            {feedback && <p className="account-error draft-feedback" role="alert">{feedback}</p>}
            <DraftAuthModal
                isOpen={isAuthModalOpen}
                onClose={() => setIsAuthModalOpen(false)}
                onAuthenticated={persistDraft}
            />
        </>
    );
}

export default DraftSaveControl;